import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Button,
  Space,
  Modal,
  message,
} from "antd";
import { Table } from "ant-table-extensions";
import http from "../../helpers/http";
import helper from "../../helpers/helper";
import config from "../../config/config";
import { useTranslation } from "react-i18next";
import { ExclamationCircleOutlined, DeleteOutlined } from "@ant-design/icons";

const { confirm } = Modal;

function NewsletterList() {
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState([]);
  const { t } = useTranslation();

  const moduleNamePural = "Newsletter Subscribers";
  const base_url = config.api_url + "admin/newsletter/subscribers";

  const fetchDatas = async () => {
    setLoading(true);
    try {
      const response = await http.get(base_url);
      if (response && response.data) {
        setDatas(response.data);
      }
    } catch (error) {
      message.error("Failed to fetch subscribers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  const handleDelete = (id) => {
    confirm({
      title: "Are you sure you want to delete this subscriber?",
      icon: <ExclamationCircleOutlined />,
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          await http.delete(`${base_url}/${id}`);
          message.success("Subscriber deleted successfully");
          fetchDatas();
        } catch (error) {
          message.error("Failed to delete subscriber");
        }
      },
    });
  };

  const fields = {
    email: "Email",
  };

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => helper.ISTDate(text),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Breadcrumb
        style={{ margin: "16px 0" }}
        items={[
          {
            title: "JagKris",
          },
          {
            title: moduleNamePural,
          },
        ]}
      />

      <Row>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} bordered={false}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={datas}
                loading={loading}
                exportableProps={{
                  showColumnPicker: false,
                  fields,
                  fileName: moduleNamePural,
                  children: "Export to CSV",
                }}
                searchable
              />
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default NewsletterList;
